import * as React from 'react';
import {Motion, spring} from 'react-motion';

import styles from './send-progress.module.css';

type Props = {
    color: string;
    isSending: boolean;
    isComplete: boolean;
    timeoutInMs: number;
};

export function SendProgress(props: Props) {
    const [percentComplete, setPercentComplete] = React.useState(0);

    React.useEffect(() => {
        if (props.isSending) {
            const interval = setInterval(() => {
                setPercentComplete((prev) => Math.min(prev + 0.1, 0.9));
            }, props.timeoutInMs / 20);

            return () => clearInterval(interval);
        }
    }, [props.timeoutInMs, props.isSending]);

    React.useEffect(() => {
        if (props.isComplete) {
            setPercentComplete(1);
        }
    }, [props.isComplete]);

    // @ts-expect-error
    const barStyle = (interpolated) => ({
        width: `${interpolated.x * 100}%`,
        height: 3,
        backgroundColor: props.color,
    });

    return (
        <div className={styles.bar}>
            <Motion style={{x: spring(percentComplete)}}>
                {(interpolatedStyle) => <div style={barStyle(interpolatedStyle)} />}
            </Motion>
        </div>
    );
}
